import useFetchData from 'hooks/useFetchData';
import useOrganization from 'hooks/useOrganization';
import useLoginStore from 'store/loginStore';
import { entitiesDontNeedOrganizationId } from 'utils/apiFunctions';

export default function useFetchEntities (entity, { filters, relations, extraAttributes, onlyAttributes, search, subrole, leanRelations } = {}) {
  const { organization } = useOrganization();
  const ORGANIZATION_ID = organization?.organizationId;
  const currentRole = useLoginStore(s => s.getCurrentRole)();

  filters = filters ?? {};
  if (entitiesDontNeedOrganizationId.indexOf(entity) == -1) {
      filters = { ...filters, 'organizationId': ORGANIZATION_ID };
  }

  const params = new URLSearchParams();
  params.append('entity', entity);
  params.append('relations', relations ?? '');
  params.append('extraAttributes', extraAttributes ?? '');
  params.append('onlyAttributes', onlyAttributes ?? '');
  params.append('search', search ?? '');
  if (subrole) {
    params.append('subrole', subrole);
  }
  if (leanRelations) {
    // HMS-75: backend loads only the explicitly listed fields of relations (opt-in, see getIncludesLean in BE)
    params.append('leanRelations', '1');
  }
  if (currentRole) {
    params.append('role', currentRole);
  }
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined) {
      params.append(key, JSON.stringify(value));
    }
  }

  const { data, status, isLoading, isNotFound, isError, reload } = useFetchData(
      entity
        ? `/admin/entities?${params.toString()}`
        : null
  );

  return { data, status, isLoading, isNotFound, isError, reload };
}